"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.ArrowDownIcon = function (props) {
    var fillColor = props.disabled ? "#B3B7BA" : "#6E757A";
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "16", height: "16", viewBox: "0 0 16 16" },
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: "a", d: "M0 0h8L4 4z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(4 6)" },
            react_1.default.createElement("mask", { id: "b", fill: "#fff" },
                react_1.default.createElement("use", { xlinkHref: "#a" })),
            react_1.default.createElement("use", { fill: "#000", xlinkHref: "#a" }),
            react_1.default.createElement("g", { fill: fillColor, mask: "url(#b)" },
                react_1.default.createElement("path", { d: "M-4-6h16v16H-4z" })))));
};
